import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Phone, MessageCircle } from "lucide-react";
import Logo from "./Logo";
import { PHONE_DISPLAY, PHONE_TEL, WHATSAPP_URL, scrollToId } from "../lib/site";

const LINKS = [
  { id: "prezzi", label: "Prezzi" },
  { id: "calcolatore", label: "Calcola il prezzo" },
  { id: "lavori", label: "Lavori" },
  { id: "sopralluogo", label: "Sopralluogo gratuito" },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -70, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.9, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed inset-x-0 top-0 z-50 transition-[background-color,backdrop-filter,border-color] duration-500 ${
        scrolled
          ? "border-b border-white/10 bg-walnut/85 backdrop-blur-xl"
          : "border-b border-transparent bg-transparent"
      }`}
      data-testid="main-navbar"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-3 md:px-10">
        <button
          onClick={() => window.__lenis?.scrollTo(0, { duration: 1.4 })}
          data-testid="nav-logo-button"
          aria-label="Torna su"
        >
          <Logo light />
        </button>
        <nav className="hidden items-center gap-8 lg:flex">
          {LINKS.map((l) => (
            <button
              key={l.id}
              onClick={() => scrollToId(l.id)}
              data-testid={`nav-link-${l.id}`}
              className="group relative font-sans text-sm font-light tracking-wide text-sand/85 transition-colors duration-300 hover:text-sand"
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-honey transition-[width] duration-300 group-hover:w-full" />
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <a
            href={`tel:${PHONE_TEL}`}
            data-testid="nav-phone-button"
            className="flex items-center gap-2 rounded-full border border-honey/50 px-4 py-2 font-sans text-sm text-sand transition-colors duration-300 hover:bg-honey hover:text-ink"
          >
            <Phone size={15} strokeWidth={1.8} />
            <span className="hidden sm:inline">{PHONE_DISPLAY}</span>
          </a>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-whatsapp-button"
            aria-label="Scrivici su WhatsApp"
            className="flex h-9 w-9 items-center justify-center rounded-full bg-[#25D366] text-white transition-transform duration-300 hover:scale-110"
          >
            <MessageCircle size={16} strokeWidth={1.8} />
          </a>
        </div>
      </div>
    </motion.header>
  );
};

export default Navbar;
